export { ContentArea } from './ContentArea';
export type { Props } from './ContentArea.types';
